document.addEventListener("turbolinks:load", function() {

  editor = "";

  if ($("#recommend-retargeting-html").length > 0) {
    editor = ace.edit("recommend-retargeting-html");
    editor.session.setMode("ace/mode/html");
    editor.setTheme("ace/theme/twilight");
  
    // タブのスペース数を設定
    editor.getSession().setTabSize(2);
  
    // セッションの変更時のイベントを監視
    editor.session.on('changeAnnotation', function() {
      let annotations = editor.session.getAnnotations() || [], i = len = annotations.length;
      while (i--) {
        if(/important/.test(annotations[i].text)) { // !importantに関する警告をチェック
          annotations.splice(i, 1);
        }
      }
      if (len > annotations.length) {
        editor.session.setAnnotations(annotations);
      }
    });
  }

  // #################################################################
  // リターゲティング設定の公開/非公開設定
  // #################################################################
   $('.recommend_retargeting_setting_show_valid_selects').on('change', function (event) {
    let recommend_retargeting_setting_id = $('#recommend-retargeting-setting-id').val();
    let show_valid = $('.recommend_retargeting_setting_show_valid_selects:checked').val();

    $.ajax({
      url: '/recommend_retargeting_setting/update_recommend_retargeting_setting_show_valid',
      type: 'POST',
      data: {
        id: recommend_retargeting_setting_id,
        show_valid: show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // リターゲティング設定のフリークエンシー設定
  // #################################################################
   $('#recommend-retargeting-days-after-purchase').on('change', function (event) {
    let recommend_retargeting_setting_id = $('#recommend-retargeting-setting-id').val();
    let days_after_purchase = $('#recommend-retargeting-days-after-purchase').val();

    $.ajax({
      url: '/recommend_retargeting_setting/update_recommend_retargeting_setting_days_after_purchase',
      type: 'POST',
      data: {
        id: recommend_retargeting_setting_id,
        days_after_purchase: days_after_purchase
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  
  // #################################################################
  // リターゲティング設定の表示URL設定
  // #################################################################
  $('#recommend_retargeting_setting_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="recommend_retargeting_setting_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="recommend_retargeting_setting_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.recommend_retargeting_setting_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.recommend_retargeting_setting_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#recommend_retargeting_setting_url_set').on('click', function () {
    let recommend_retargeting_setting_id = $('#recommend-retargeting-setting-id').val();
    let urls = [];
    $('.recommend_retargeting_setting_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/recommend_retargeting_setting/set_recommend_retargeting_setting_url',
      type: 'POST',
      data: {
        recommend_retargeting_setting_id: recommend_retargeting_setting_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });


  // #################################################################
  // リターゲティング設定の表示URL設定
  // #################################################################
  $('#recommend_retargeting_setting_excluded_url_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="recommend_retargeting_setting_excluded_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="recommend_retargeting_setting_excluded_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.recommend_retargeting_setting_excluded_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.recommend_retargeting_setting_excluded_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#recommend_retargeting_setting_excluded_url_set').on('click', function () {
    let recommend_retargeting_setting_id = $('#recommend-retargeting-setting-id').val();
    let urls = [];
    $('.recommend_retargeting_setting_excluded_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/recommend_retargeting_setting/set_recommend_retargeting_setting_excluded_url',
      type: 'POST',
      data: {
        recommend_retargeting_setting_id: recommend_retargeting_setting_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // リターゲティング設定のHTML設定
  // #################################################################
  $('#update-recommend-retargeting-html').on('click', function () {
    let caller = $(this);
    caller.css('pointer-events', 'none');
    let htmlVal = editor.getValue();

    $.ajax({
      url: '/recommend_retargeting_setting/update_retargeting_html_property',
      type: 'POST',
      data: {
        id: $('#recommend-retargeting-setting-id').val(),
        html_val: htmlVal,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        if (data.message!='') {
          alert(data.message);
        } else {
          alert('登録しました');
        }
        location.reload();
      } else {
        alert(data.message);
      }
    })
    .fail(function(){
      alert('登録に失敗しました');
    });
    caller.css('pointer-events', 'auto');
  });

  // ------------------------------------------------------------------------------------------------
  // 分析
  // ------------------------------------------------------------------------------------------------
  function recommend_retargeting_update_url() {
    const recommend_retargeting_setting_id = $('#recommend_retargeting_metric_selects option:selected').val();
    const gf = $('#recommend_retargeting_metric_graph_pattern_select_input').val();
    const start_day = $('#recommend_retargeting_metric_report_start_day').val();
    const end_day = $('#recommend_retargeting_metric_report_end_day').val();
    const device = $('.recommend_retargeting_metric_device_select').data("device");

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (recommend_retargeting_setting_id !== 'none' && recommend_retargeting_setting_id !== null && recommend_retargeting_setting_id !== undefined) {
      params.set('recommend_retargeting_setting_id', recommend_retargeting_setting_id);
    } else {
      params.delete('recommend_retargeting_setting_id');
    }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    if (device == "0" || device == "1" || device == "2") {
      params.set('device', device);
    } else {
      params.delete('device');
    }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {  // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // レコメンドコメンドューの選択
  // #################################################################
  $('#recommend_retargeting_metric_selects').on('change', function () {
    recommend_retargeting_update_url();
  });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.recommend_retargeting_metric_graph_pattern_select_day, .recommend_retargeting_metric_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#recommend_retargeting_metric_graph_pattern_select_input').val(gf_value);
    recommend_retargeting_update_url();
  });

  // #################################################################
  // デバイスごとのグラフ切り替え
  // #################################################################
  $('.recommend_retargeting_metric_device_select_all, .recommend_retargeting_metric_device_select_pc, .recommend_retargeting_metric_device_select_phone').on('click', function () {
    const device = $(this).data('device');
    $('.recommend_retargeting_metric_device_select').data("device", device);
    recommend_retargeting_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#recommend_retargeting_metric_report_start_day, #recommend_retargeting_metric_report_end_day').on('change', function () {
    recommend_retargeting_update_url();
  });

  // #################################################################
  // レコメンドグデータのみの削除
  // #################################################################
  $('.delete_recommend_retargeting_metric_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const recommend_retargeting_setting_id = $('#recommend_retargeting_metric_selects option:selected').val();

    $.ajax({
      url: '/recommend_retargeting_report/delete_recommend_retargeting_log',
      type: 'POST',
      data: {
        recommend_retargeting_setting_id: recommend_retargeting_setting_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // レコメンドグデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_recommend_retargeting_metric_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const recommend_retargeting_setting_id = $('#recommend_retargeting_metric_selects option:selected').val();

    $.ajax({
      url: '/recommend_retargeting_report/delete_recommend_retargeting_log_and_related_data',
      type: 'POST',
      data: {
        recommend_retargeting_setting_id: recommend_retargeting_setting_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.href = '/recommend_retargeting_report/index';
      }
    });
  });

  // #################################################################
  // レコメンドポートのcsv出力
  // #################################################################
  $('#download_recommend_retargeting_metric_csv').on('click', function () {
    const recommend_retargeting_setting_id = $('#recommend_retargeting_metric_selects option:selected').val();
    const month = $('#ua_recommend_retargeting_metric_month_selects option:selected').val();

    let href = '/download_recommend_retargeting_metric_csv';

    href += `?recommend_retargeting_setting_id=${recommend_retargeting_setting_id}`;
    href += `&m=${month}`;
    location.href = href;
  });

  $('#ua_recommend_retargeting_metric_month_selects').on('change', function () {
    let month = $('#ua_recommend_retargeting_metric_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      location.reload();
    }
  });
});
